module.exports = __webpack_public_path__ + "img/full3-min.f6e8a0a1.png";